import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const BackArrowIcon = (props: SvgProps) => (
  <Svg
    width={29}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#FDFBF9"
      fillRule="evenodd"
      d="M12 0c0 1.22-.182 2.399-.521 3.509a12.028 12.028 0 0 1-7.97 7.97C2.399 11.818 1.22 12 0 12c1.22 0 2.399.182 3.509.521a12.028 12.028 0 0 1 7.97 7.97C11.818 21.601 12 22.78 12 24v-5.009A13.045 13.045 0 0 0 5.009 12 13.045 13.045 0 0 0 12 5.009V0Z"
      clipRule="evenodd"
    />
    <Path stroke="#FDFBF9" d="M4.5 12h24" />
  </Svg>
)
export default BackArrowIcon
